import store from "@/store";
import TRTCUtilStudent from "./TRTCUtilStudent";
import TRTCUtilTeacher from "./TRTCUtilTeacher";
let webSocket = null;
let webSocketStateInterval = null;
let heartInterval = null;
let _closeType = false; // true主动挂断 false被动挂断
let alarmNotice = 0;
let alarmMsg = 0;
let studentUserId = null;

export default {
    initWebsocket() {
        let _that = this;
        let _userId = store.state.user.userInfo.userId;
        const wsuri = process.env.VUE_APP_wsBaseURL + "/msgSocket/" + _userId;
        webSocket = new WebSocket(wsuri);
        webSocket.onopen = function (event) {
            // console.log("webSocket onopen ----->", event);

            // heartInterval = setInterval(function() {
            //     webSocket.send(JSON.stringify({ cmd: 100 }));
            // }, 10000);

            webSocketStateInterval = setInterval(function () {
                switch (webSocket.readyState) {
                    case WebSocket.CONNECTING:
                        console.log("webSocket连接中---->");
                        break;
                    case WebSocket.OPEN:
                        console.log("webSocket打开中---->");
                        webSocket.send(JSON.stringify({heart : "心跳"}));
                        break;
                    case WebSocket.CLOSING:
                        console.log("webSocket关闭中---->");
                        break;
                    case WebSocket.CLOSED:
                        console.log("webSocket关闭成功---->");
                        if (webSocketStateInterval) {
                            clearInterval(webSocketStateInterval);
                        }
                        if (_closeType === false) {
                            _that.initWebsocket();
                        }
                        break;
                    default:
                        console.log("webSocket-------");
                        break;
                }
            }, 5000);
        };
        webSocket.onmessage = function (event) {
            console.log("webSocket onmessage ----->", event);
            let message = JSON.parse(event.data);
            console.log("message----->", message);
            if (message.cmd === 0) {
                // 直播聊天
                let date = new Date();
                let _time = date.getHours() + ":" + date.getMinutes();
                let _message = message;
                _message.time = _time;
                store.commit("setLiveMessage", _message);
            } else if (message.cmd === 1) {
                // 禁学员麦
                TRTCUtilStudent.setMuteAudio();
            } else if (message.cmd === 2) {
                // 开学员麦
                TRTCUtilStudent.setUnmuteAudio();
            } else if (message.cmd === 3) {
                // 当学员分享自己的屏幕时，关闭教师的屏幕
                studentUserId = message.sender;
                TRTCUtilTeacher.setShareScreen();
            } else if (message.cmd === 4) {
                // 当教师分享自己的屏幕时，关闭学员的屏幕
                TRTCUtilStudent.setShareScreen();
            } else {
                // alarmMsg++;
                // store.commit("setAlarmMsg", alarmMsg);
                // store.dispatch("messageListAction", message);
            }
        };
        webSocket.onerror = function (event) {
            console.log("webSocket onerror ----->", event);
            _that.initWebsocket();
        };
        webSocket.onclose = function (event) {
            console.log("webSocket onclose --->", event);
            if (_closeType) {
                if (webSocketStateInterval) {
                    clearInterval(webSocketStateInterval);
                }
            }
            if (heartInterval) {
                clearInterval(heartInterval);
            }
            _closeType = false;
        };
        // return new Promise((resolve, reject) => {resolve()});
    },
    sendWebSocket(text) {
        webSocket.send(JSON.stringify(text));
    },
    getStudentUserId() {
        return studentUserId;
    },
    closeWebSocket(closeType) {
        _closeType = closeType;
        if (webSocket) {
            webSocket.close();
        }
    },
};
